var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2476 0.555664H4.75249C2.68278 0.555664 1.00494 2.2335 1.00494 4.30321V11.7983C1.00494 13.868 2.68278 15.5458 4.75249 15.5458H12.2476C14.3173 15.5458 15.9951 13.868 15.9951 11.7983V4.30321C15.9951 2.2335 14.3173 0.555664 12.2476 0.555664Z",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5016 7.57979C11.5942 8.20381 11.4876 8.84112 11.197 9.40107C10.9065 9.96102 10.4468 10.4151 9.88328 10.6987C9.31978 10.9823 8.68121 11.0811 8.05838 10.9808C7.43554 10.8806 6.86017 10.5866 6.4141 10.1405C5.96802 9.69441 5.67396 9.11904 5.57374 8.49621C5.47352 7.87338 5.57224 7.2348 5.85586 6.67131C6.13948 6.10782 6.59356 5.6481 7.15351 5.35755C7.71346 5.067 8.35077 4.96042 8.9748 5.05295C9.61132 5.14734 10.2006 5.44395 10.6556 5.89896C11.1106 6.35397 11.4072 6.94326 11.5016 7.57979Z",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6233 3.92871H12.63",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.2faa6fd6.svg";
export { ForwardRef as ReactComponent };